<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />
    <HeaderResponsive />
    <div class="container">
      <SecondHeader />
      <p class="title_section">Noticias</p>

      <div class="carousel_noticias_desktop">
        <carousel :per-page="2" paginationActiveColor="#3366CC" id="carousel_noticias">
          <slide class="container_noticias" v-for="(item, index) in items" :key="index">
            <div class="card mb-3" style="max-width:100%">
              <div class="row">
                <div class="col-md-4">
                  <img
                    style="object-fit: cover;"
                    :src="item.filesLink[0]"
                    class="card-img"
                    alt="imagen"
                  />
                </div>
                <div class="col-md-8">
                  <div style="padding-top: 25px;">
                    <h5 class> {{item.experienceId && item.experienceId > 0 ? "EXP-" + item.experienceId: ""}} {{ item.title }}</h5>
                    <h6 class>
                      <font-awesome-icon class icon="calendar" :style="{ color: 'red' }" />
                        {{ formatDate(item.date)}}
                    </h6>
                    <p style>{{getDescription(item)}}</p>
                    <a v-if="!item.more" @click="toggleMore(item)" style="color:#6699FF;text-decoration:underline;cursor: pointer;">
                      <strong>Ver más</strong>
                    </a>
                    <a v-else href="#" @click="toggleMore(item)" style="color:#6699FF;text-decoration:underline;cursor: pointer;">
                      <strong>Ver menos</strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
<!-- :navigate-to="someLocalProperty" -->
      <div class="carousel_noticias_mobile">
        <carousel
          :per-page="1"
          paginationActiveColor="#3366CC"
          id="carousel_noticias"
        >
          <slide class="container_noticias" v-for="(item, index) in this.items" :key="index">
            <div class="card mb-3" style="max-width: 540px;">
              <div class="row no-gutters">
                <div class="col-md-4">
                  <img
                    style="object-fit: cover;"
                    :src="item.filesLink[0]"
                    class="card-img"
                    alt="imagen"
                  />
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title">{{ item.title }}</h5>
                    <h6 class="noticia_fecha">{{ item.date }}</h6>
                    <p style>{{item.description.substr(0, 90)}}</p>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>

      <Mapa />
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import Mapa from "./partials/Mapa";
import { Carousel, Slide } from "./carrousel";
import axios from "axios";
import { format } from "date-fns";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from '../../helpers/config';

export default {
  mounted() {
    this.getNews();
  },
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Mapa,
    Carousel,
    Slide,
    Loading
  },
  data() {
    return {
      items: [],
      isLoading: false,
      fullPage: true
    };
  },
  methods: {
    toggleMore(item) {
      const isExp = item.experienceId && item.experienceId > 0
      if (isExp) {
        this.$router.push({ name: 'DetalleExp', query: { user_id: item.experienceId } })
      }
      item.more = !item.more
    },
    getDescription(item) {
      if (!item.more)
        return item.description.substr(0, 80) + "..."
      return item.description
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    async getFixExperiences(exp) {
      /*exp.map(ex => {
        aw
      })*/
      return []
    },
    fixData(data) {
      const experiences = data.filter(dat => dat.experienceId > 0)
      const news = data.filter(dat => dat.experienceId === 0)
      
      return [...experiences, ...news]
    },
    getNews() {
      this.isLoading = true;
      axios
        .get(`${config.urlApi}/news?filter[limit]=8&filter[where][statusId]=1`, {})
        .then(({ data }) => {
          //const auxData = this.fixData(data)
          data.map(exp => {
            exp.more = false
          })
          this.items = data;
          this.items = this.items.reverse();
          this.isLoading = false;
        })
        .catch(function(error) {
          ////console.log(error)
        });
    },

  },
  computed: {
  }
};
</script>


<style>
#carousel_noticias {
  margin-top: -30px !important;
}
.container_noticias {
  padding-left: 10px;
}
.card {
    width: 100% !important;
}

.card-img {
  height: 100% !important;
}
.noticia_fecha {
  line-height: 0.4;
  padding-bottom: 12px;
}
.VueCarousel-pagination {
  margin-top: -30px !important;
}
.VueCarousel-pagination {
  text-align: right !important;
  padding-right: 5px !important;
}
.VueCarousel-dot {
  background-color: #b1b2b3 !important;
}
.VueCarousel-dot.VueCarousel-dot--active {

}
.VueCarousel-navigation-button {
  color: #3366cc !important;
}
.VueCarousel-navigation--disabled {
  color: #b1b2b3 !important;
}
.card-img {
  height: 200px !important;
}

@media (max-width: 768px) {
  .carousel_noticias_desktop {
    display: none;
  }
  .carousel_noticias_mobile {
    display: block;
  }
  #carousel_noticias {
    margin-top: 0px !important;
  }
}

@media (min-width: 768px) {
  .carousel_noticias_desktop {
    display: block;
  }
  .carousel_noticias_mobile {
    display: none;
  }
}
</style>
